import PropTypes from "prop-types";
import currencyType from "./currencyType";

export default PropTypes.shape({
  applications: PropTypes.arrayOf(PropTypes.shape({})),
  applicationsCount: PropTypes.number,
  cvLimit: PropTypes.number,
  degreeRequired: PropTypes.bool,
  employer: PropTypes.shape({
    accountManager: PropTypes.string,
    customTerms: PropTypes.string,
    name: PropTypes.string,
  }),
  feedbackTimescale: PropTypes.shape({
    description: PropTypes.string,
  }),
  filledPositionsCount: PropTypes.number,
  hasNewApplications: PropTypes.bool,
  hasNewEngagements: PropTypes.bool,
  interviewStages: PropTypes.number,
  jobType: PropTypes.string,
  keySkills: PropTypes.string,
  keywords: PropTypes.string,
  listedAt: PropTypes.string,
  location: PropTypes.string,
  offerMade: PropTypes.bool,
  perecntageFee: PropTypes.bool,
  placementFeePercent: PropTypes.number,
  readApplicationsCount: PropTypes.number,
  relocationAssistance: PropTypes.bool,
  salary: PropTypes.number,
  sector: PropTypes.shape({
    name: PropTypes.string,
  }),
  status: PropTypes.string,
  title: PropTypes.string,
  unreadApplicationsCount: PropTypes.number,
  vacancyReason: PropTypes.string,
  visaSponsorship: PropTypes.bool,
  currency: currencyType,
});
